import { useCallback } from 'react';
import { z } from 'zod';
import { ExtensionDefinition, MediaType } from './model';
import { useLocalStorageBackedState } from './viewers/common/3d/useLocalStoreBackedState';

// Ключ постоянный, карта выбора по оригинальным URL (MYUA-17117). Динамический ключ не годится:
// useLocalStorageBackedState читает localStorage один раз в useState и не перечитывает при смене
// ключа, а AssetDetails и BasePreview монтируются ещё без ассета. Константы модуля — стабильные
// ссылки для deps внутри хука.
const EMPTY: Partial<Record<string, MediaType>> = {};
const SCHEMA = z.record(z.nativeEnum(MediaType));
const KEY = 'fullscreenPreview.viewerByAsset';

/**
 * Выбранный пользователем просмотрщик для конкретного файла. Хранится в localStorage
 * по точному оригинальному URL; экземпляры (сайдбар и полноэкранный режим) синхронизируются через
 * LocalStateChangeEvent. Значение не проверяется на допустимость — для этого sanitizeViewer.
 */
export function useViewerChoice(
  _d: ExtensionDefinition | undefined | null,
  originalSrc: string | null | undefined,
): [MediaType | null, (mt: MediaType) => void] {
  const [store, setStore] = useLocalStorageBackedState<Partial<Record<string, MediaType>>>(
    EMPTY,
    SCHEMA,
    KEY,
  );
  const value = originalSrc ? store[originalSrc] ?? null : null;
  const set = useCallback(
    (mt: MediaType) => {
      if (originalSrc) setStore((s) => ({ ...s, [originalSrc]: mt }));
    },
    [originalSrc, setStore],
  );
  return [value, set];
}
